var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../../../../service/api.service';
import { ContentBaseService } from '../../../../../component/base/contentbase.service';
import { Option } from '../../../../../models/option/option';
var KtsDepartmentService = /** @class */ (function (_super) {
    __extends(KtsDepartmentService, _super);
    function KtsDepartmentService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        _this.options = {};
        return _this;
    }
    KtsDepartmentService.prototype.sortItems = function (items) {
        items.sort(function (a, b) {
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            return 0;
        });
    };
    KtsDepartmentService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    KtsDepartmentService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return KtsDepartmentService;
}(ContentBaseService));
export { KtsDepartmentService };
var DepartmentOption = /** @class */ (function (_super) {
    __extends(DepartmentOption, _super);
    function DepartmentOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DepartmentOption;
}(Option));
export { DepartmentOption };
//# sourceMappingURL=department.service.js.map